import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/RegisterTrainer.css';

const RegisterTrainer = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Restore data if returning from RegisterSchool
    const [formData, setFormData] = useState(
        location.state?.trainerData || {
            password: '',
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            country: '',
            city: '',
            postalCode: '',
            street: '',
            buildingNumber: '',
            apartmentNumber: '',
            statuteAccepted: false,
        }
    );
    const [error, setError] = useState('');

    // Store schoolData if user is navigating back
    const schoolData = location.state?.schoolData || null;

    const handleChange = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setFormData({ ...formData, [e.target.name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        // Navigate to school registration, passing trainer data and any existing school data
        navigate('/register-school', {
            state: {
                trainerData: formData,
                schoolData: schoolData
            }
        });
    };

    const handleBack = () => {
        navigate(-1); // Navigate back to previous page
    };

    return (
        <div className="trainer-registration">
            <div className="trainer-registration__left-panel">
                <div className="trainer-registration__left-content">
                    <h2 className="trainer-registration__welcome-text">
                        Dziękujemy, że
                        <span className="trainer-registration__welcome-text--highlight">nas wybrałeś</span>
                    </h2>
                </div>
            </div>
            <div className="trainer-registration__right-panel">
                <button className="trainer-registration__back-btn" onClick={handleBack}>
                    ← wróć
                </button>
                <div className="trainer-registration__form-wrapper">
                    <h1 className="trainer-registration__title">Zarejestruj się jako trener</h1>
                    <form className="trainer-registration__form" onSubmit={handleSubmit}>
                        <div className="trainer-registration__form-row">
                            <div className="trainer-registration__field-group">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="E-mail"
                                    className="trainer-registration__input"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="trainer-registration__field-group">
                                <input
                                    type="password"
                                    name="password"
                                    placeholder="Hasło"
                                    className="trainer-registration__input"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="trainer-registration__form-row">
                            <div className="trainer-registration__field-group">
                                <input
                                    type="text"
                                    name="firstName"
                                    placeholder="Imię"
                                    className="trainer-registration__input"
                                    value={formData.firstName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="trainer-registration__field-group">
                                <input
                                    type="text"
                                    name="lastName"
                                    placeholder="Nazwisko"
                                    className="trainer-registration__input"
                                    value={formData.lastName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="trainer-registration__form-row">
                            <div className="trainer-registration__field-group">
                                <input
                                    type="text"
                                    name="phone"
                                    placeholder="Numer telefonu"
                                    className="trainer-registration__input"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="trainer-registration__field-group">
                                <input
                                    type="text"
                                    name="country"
                                    placeholder="Kraj"
                                    className="trainer-registration__input"
                                    value={formData.country}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="trainer-registration__form-row">
                            <div className="trainer-registration__field-group">
                                <input
                                    type="text"
                                    name="city"
                                    placeholder="Miasto"
                                    className="trainer-registration__input"
                                    value={formData.city}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="trainer-registration__field-group">
                                <input
                                    type="text"
                                    name="postalCode"
                                    placeholder="Kod pocztowy"
                                    className="trainer-registration__input"
                                    value={formData.postalCode}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>

                        <div className="trainer-registration__form-row trainer-registration__form-row--three-cols">
                            <div className="trainer-registration__field-group">
                                <input
                                    type="text"
                                    name="street"
                                    placeholder="Ulica"
                                    className="trainer-registration__input"
                                    value={formData.street}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="trainer-registration__field-group">
                                <input
                                    type="text"
                                    name="buildingNumber"
                                    placeholder="Numer budynku"
                                    className="trainer-registration__input"
                                    value={formData.buildingNumber}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="trainer-registration__field-group">
                                <input
                                    type="text"
                                    name="apartmentNumber"
                                    placeholder="Numer mieszkania"
                                    className="trainer-registration__input"
                                    value={formData.apartmentNumber}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="trainer-registration__checkbox-group">
                            <label className="trainer-registration__checkbox-label">
                                <input
                                    type="checkbox"
                                    name="statuteAccepted"
                                    checked={formData.statuteAccepted}
                                    onChange={handleChange}
                                    required
                                    className="trainer-registration__checkbox"
                                />
                                <span>Akceptuję regulamin aplikacji</span>
                            </label>
                        </div>

                        {error && <div className="trainer-registration__error">{error}</div>}

                        <button type="submit" className="trainer-registration__submit-btn">
                            dalej →
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default RegisterTrainer;